@if (isCompact && warningsLabel) {
  <button mat-icon-button (click)="onWarningsClick()" matTooltip="Weather Warning Detail" matTooltipPosition="below">
    <mat-icon>priority_high</mat-icon>
  </button>
} @else if (warningsLabel) {
  <div class="warnings" (click)="onWarningsClick()">
    {{ warningsLabel }}
  </div>
}
@if (configuration && temperatureInCelsius !== undefined) {
  <button mat-icon-button
          class="weather-state"
          (click)="onWeatherClick()"
          [matTooltip]="stationName || 'Invalid observation data'"
  >
    <div class="temperature">
      @if (!configuration.useMetricSystem) {
        <span>{{ getTemperature() }}°F</span>
      } @else {
        <span>{{ getTemperature() }}°C</span>
      }
    </div>
    @if (weatherIcon && temperatureInCelsius !== null) {
      <div class="weather-icon">
        <mat-icon>
          {{ weatherIcon }}
        </mat-icon>
      </div>
    }
  </button>
}

